/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpServersList } from "../funcs/mcpServersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMcpServersResult } from "../models/components/listmcpserversresult.js";
import {
  ListMcpServersRequest,
  ListMcpServersSecurity,
} from "../models/operations/listmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type McpServersQueryData = ListMcpServersResult;

export function prefetchMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMcpServersRequest | undefined,
  security?: ListMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpServersQuery(
  client$: GramCore,
  request?: ListMcpServersRequest | undefined,
  security?: ListMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<McpServersQueryData>;
} {
  return {
    queryKey: queryKeyMcpServers({
      remoteMcpServerId: request?.remoteMcpServerId,
      tunneledMcpServerId: request?.tunneledMcpServerId,
      toolsetId: request?.toolsetId,
      unproxiedMcpServerId: request?.unproxiedMcpServerId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function mcpServersQueryFn(
      ctx,
    ): Promise<McpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpServersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpServers(
  parameters: {
    remoteMcpServerId?: string | undefined;
    tunneledMcpServerId?: string | undefined;
    toolsetId?: string | undefined;
    unproxiedMcpServerId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpServers", "list", parameters];
}
